import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AddinsCommon" */ './lazyIndex')
);

export let lazyForgottenAttachmentsToggle = new LazyImport(
    lazyModule,
    m => m.getForgottenAttachmentsDialogToggle
);

export { default as checkForForgottenAttachments } from './utils/checkForForgottenAttachments';
